import {
  resolvePreferOpenRouter,
  resolvePreferOpenRouterFromOptions,
  readPreferOpenRouterFromEnv,
} from "@x12i/ai-profiles";
import type { PreferOpenRouterOptions } from "./types.js";

export { readPreferOpenRouterFromEnv, resolvePreferOpenRouter };

/**
 * Resolve OpenRouter preference for invoke-time routing.
 * Delegates to `@x12i/ai-profiles` {@link resolvePreferOpenRouter}.
 */
export function resolvePreferOpenRouterPreference(
  options?: boolean | PreferOpenRouterOptions,
): boolean {
  if (typeof options === "boolean") {
    return resolvePreferOpenRouter(options);
  }
  return resolvePreferOpenRouterFromOptions(options);
}

function isEnvPlaceholder(value: string): boolean {
  return /^ENV\./i.test(value.trim());
}

/**
 * Resolve OpenRouter API key from explicit option or OPENROUTER_API_KEY env.
 */
export function resolveOpenRouterApiKey(
  explicit?: string,
  env: Record<string, string | undefined> = process.env,
): string | undefined {
  const trimmed = explicit?.trim();
  if (trimmed && !isEnvPlaceholder(trimmed)) return trimmed;
  const fromEnv = env.OPENROUTER_API_KEY?.trim();
  return fromEnv || undefined;
}
